// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.leaflet-container {
  height: 600px;
  width: 100%;
}

.my-location {
  background-color: red; /* Change the background color */
  border-radius: 100%; 
  width: 15px;
  height: 15px;
  border: 2px solid black; /* Optional border */
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
}

.parent {
  /* margin: 1rem; */
  /* padding: 2rem 2rem; */
  text-align: left;
}
.child {
  display: inline-block;
  /* padding: 1rem ; */
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qBAAqB,EAAE,gCAAgC;EACvD,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB,EAAE,oBAAoB;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;AACxB","sourcesContent":["\n.leaflet-container {\n  height: 600px;\n  width: 100%;\n}\n\n.my-location {\n  background-color: red; /* Change the background color */\n  border-radius: 100%; \n  width: 15px;\n  height: 15px;\n  border: 2px solid black; /* Optional border */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: white;\n}\n\n.parent {\n  /* margin: 1rem; */\n  /* padding: 2rem 2rem; */\n  text-align: left;\n}\n.child {\n  display: inline-block;\n  /* padding: 1rem ; */\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
